import React from 'react'
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import Skeleton from 'Components/skeleton/Skeleton'

const LoaderWrapper = ({ children, loading, className }) => {
    if (loading)
        return <Skeleton extraClass={className} />
    return <>{children}</>
}

export default withFeatureSafe(LoaderWrapper);